import styled from 'styled-components';

export const TechnicianStyled = styled.div`
  margin-top: 18px;

  & .table-container {
    margin-bottom: 20px;
  }
`;
